import clsx from "clsx";

export function InputGroup({ light = false, children }) {
  return (
    <div
      className={clsx(
        "question__input-group",
        light && "question__input-group--light",
      )}
    >
      {children}
    </div>
  );
}
